import { render, staticRenderFns } from "./PromoRibbonModule.vue?vue&type=template&id=0ae3f701&"
import script from "./PromoRibbonModule.ts?vue&type=script&lang=ts&"
export * from "./PromoRibbonModule.ts?vue&type=script&lang=ts&"
import style0 from "./PromoRibbonModule.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports